import { MutableRefObject, useEffect, useRef, useState } from "react";
import { Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { HexPatternIntervals } from "../../Exercises/HexPattern/HexPatternIntervals";
import { HexPatternPositions } from "../../Exercises/HexPattern/HexPatternPositions";
import { HexPatternSequence } from "../../Exercises/HexPattern/HexPatternSequence";
import '../Hex/Hex.scss'
import { HexBuilder } from "../../Exercises/HexBuilder/HexBuilder";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { CircleOfFifths} from "../../../Comps/NoteCircle/NoteCircle";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { LinearChainOfFifths } from "../../../Comps/LinearChainOfFifths/LinearChainOfFifths";
import { NotesSelect } from "../../../Comps/NoteButtons/NotesSelect";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { BuildHexMap } from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { ChainOfFifthsExercise } from "../../Exercises/ChainOfFifths/ChainOfFifthsExercise";
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";
import './ChainOfFifths.scss'

export function ChainOfFifthsChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>},
        {title:'Chain of Fifths Exercise', isExercise:true, path:'chain_exercie', element:<ClearHelpers openHelpers={['Chain of Fifths']}><ChainOfFifthsExercise/></ClearHelpers>},
    ]
    return  <div>
                <h1>The Chain of Fifths</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const lastNoteTime:MutableRefObject<number> = useRef(0)
    const [selectedPositions, setSelectedPositions] = useState<number[]>([])
    const [hilitedPositions, setHilitedPositions] =  useState<number[]>([])
    //const [haloPositions, setHaloPositions] =  useState<number[]>([])
    const [tonic, setTonic] = useState<number>(Music.C)
    const [playFifthsMode, setPlayFifthsMode] = useState(false)
    const ascendingFifths:MutableRefObject<boolean> = useRef(true)
    useEffect(()=>{notePlayer.current.setTonic(tonic)}, [tonic])
    const resetTonic = (freshTonic:number) => {
        setTonic(freshTonic)
        setSelectedPositions([])
    }
    const getVisiblePositionsForLinearKey = () => {
        if(playFifthsMode){
            return [0,1,2,3,4,5,6]
        }
        return selectedPositions.concat(hilitedPositions)
    }
    const getSelectedPositionsForLinearKey = () => {
        if(!playFifthsMode){
            return []
        }
        return selectedPositions 
    }
    const onNoteClick = (note:Note) => {
        if(playFifthsMode){
            if(ascendingFifths.current){
                const fifth:number = (note.params.tonic + 7) % 12
                notePlayer.current.setTonic(note.params.tonic)
                notePlayer.current.playNotes([note.params.tonic, fifth], true, 500)
                setSelectedPositions([(note.params.noteIndex + 4) % 7])
                setHilitedPositions([note.params.noteIndex])
                return
            }
            else{
                console.log('descending')
                const fourth:number = (note.params.tonic + 5) % 12
                notePlayer.current.setTonic(fourth)
                notePlayer.current.playDescendingNotes([note.params.tonic, fourth], false, 600)
                setSelectedPositions([(note.params.noteIndex + 3) % 7])
                setHilitedPositions([note.params.noteIndex])
                return
            }
        }
        else{
            notePlayer.current.playNote(note.params.tonic, true)
        }
        
        //setHaloPositions([note.params.noteIndex])
        setHilitedPositions([note.params.noteIndex])
        setSelectedPositions(selectedPositions.concat([note.params.noteIndex]))
    }
    const getHilitedFifthNotes = () => {
        const hilitedFifthNotes:number[] = []
        const scale:number[] = Music.getKeyScale(tonic)
        hilitedPositions.forEach((position:number)=>{
            hilitedFifthNotes.push(scale[position])
        })
        return hilitedFifthNotes
    }
    const getSelectedFifthNotes = () => {
        const selecedFifthNotes:number[] = []
        const scale:number[] = Music.getKeyScale(tonic)
        selectedPositions.forEach((position:number)=>{
            selecedFifthNotes.push(scale[position])
        })
        return selecedFifthNotes
    }
    const onFifthCircleNoteClick = (noteTonic:number) => {
        const scale:number[] = Music.getKeyScale(tonic)
        const position:number = scale.indexOf(noteTonic)
        if(position > -1){
            setHilitedPositions(hilitedPositions.concat([position]))
        }
    }
    const getHexMap = () => {
        const map:HexMap = BuildHexMap({
            rows: 1,
            columns: 1,
            tonic: tonic,
            radius: 100
        })
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.notes_setSelected(selectedPositions)
        mod.notes_setHilited(hilitedPositions)
        //mod.notes_setHalo(haloPositions, true)
        return map
    }
    const width:number = 600
    const getButtonClassNames = (ascending:boolean) => {
        if(!playFifthsMode){return ''}
        if(ascendingFifths.current === ascending){
            return 'selected'
        }
        return ''
    }
    return(
        
            <div className={'chain-of-fifths Lesson'}>
                <OutlineBox title={'The Sequence of Fifth Note Positions in Each HexKey'} width={width}>
                    <LinearChainOfFifths tonic={tonic} hilitedPositions={hilitedPositions} selectedPositions={getSelectedPositionsForLinearKey()} visiblePositions={getVisiblePositionsForLinearKey()}/>
                    <div style={{display:'flex', width:width, margin:'auto'}}>
                        <div style={{flex:1}}>
                            <svg width={300} height={300}>
                                <g transform={TransformTranslate(300/2,300/2)}>
                                    <HxMapGroup onNoteClick={onNoteClick} hexMap={getHexMap()}/>
                                </g>
                            </svg>
                        </div>
                        <div style={{flex:1}}>
                            <CircleOfFifths onNoteClick={onFifthCircleNoteClick} selectedNotes={getSelectedFifthNotes()} hilitedNotes={getHilitedFifthNotes()} key={tonic} radius={100} height={300} width={300}/>
                        </div>
                    </div>
                    <NotesSelect tonic={tonic} onChange={resetTonic}/>
                    <button className={getButtonClassNames(true)} type='button' onClick={()=>{
                        ascendingFifths.current = true
                        setPlayFifthsMode(true)
                        setSelectedPositions([])
                        setHilitedPositions([])
                    }}>Play Ascending Fifths</button>
                    <button className={getButtonClassNames(false)} type='button' onClick={()=>{
                        ascendingFifths.current = false
                        setPlayFifthsMode(true)
                        setSelectedPositions([])
                        setHilitedPositions([])
                    }}>Play Descending Fifths</button>
                </OutlineBox>
            </div>
        
    )
}
export function Exercises(){
    return  <div>
                <HexPatternSequence/>
                <HexPatternPositions/>
                <HexPatternIntervals/>
                <HexBuilder/>
            </div>
}
export function Resources(){
    return <div>HexPattern Resources body</div>
}